import { useEffect, useState } from "react";
import { IPanelRosterEliminar } from "./PanelRosterEliminar";
import { codigosRespuesta, IResponseApiFluent } from "../../../../interfaces/base/IResponse";
import RosterService from "../../../../services/rosterService";

const UseRosterEliminar = (props: IPanelRosterEliminar) => {
    const [status, setStatus] = useState<codigosRespuesta>(0);
    const [mensaje, setMensaje] = useState<string>("");
    const [loading, setLoading] = useState<boolean>(false)
    const initial: string = ""
    const [request, setRequest] = useState<string>(initial)

    const deleteRoster = () => {
        setLoading(true)
        RosterService.elimminarRoster(request)
            .then((res) => {
                if (res.status == 200) {
                    setStatus(200)
                    // setMensaje("Se eliminó correctamente");
                    setMensaje(res.data.mensaje);
                    setTimeout(() => {
                        props.reload?.();
                        reset()
                    }, 3000)
                } else {
                    setStatus(500)
                }
                setLoading(false)
            })
            .catch((e) => {
                if (
                    e.response?.data &&
                    'type' in e.response.data &&
                    'title' in e.response.data &&
                    'status' in e.response.data &&
                    'instance' in e.response.data &&
                    'errors' in e.response.data
                ) {
                    const errorResponse = e.response.data as IResponseApiFluent;
                    const mensajeError = errorResponse.errors.join('\n');
                    setMensaje(mensajeError);
                } else {
                    setMensaje("Error Inesperado");
                }
                setStatus(500);
                setLoading(false);
            })
    }

    const reset = () => {
        setMensaje("")
        setRequest(initial)
        setStatus(0)
        props.onDismiss()
    }

    useEffect(() => {
        if (props.isOpen) {
            if (props.rosterData.id != initial) {
                setRequest(props.rosterData.id)
            }
        }
    }, [props.rosterData, props.isOpen])


    return { request, deleteRoster, loading, reset, mensaje, status }
}

export { UseRosterEliminar }